document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    const images = card.querySelectorAll('img');
    if (images.length < 2) return;

    const imageArray = Array.from(images);
    let current = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let isHorizontal = null;

    // 初期表示設定
    imageArray.forEach((img, i) => {
      img.style.position = i === 0 ? 'relative' : 'absolute';
      img.style.top = '0';
      img.style.left = '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.opacity = i === 0 ? '1' : '0';
      img.style.transition = 'opacity 0.3s ease';
    });

    // ドット生成
    const dots = document.createElement('div');
    dots.className = 'card__media-dots';
    imageArray.forEach((_, i) => {
      const span = document.createElement('span');
      if (i === 0) span.classList.add('active');
      dots.appendChild(span);
    });
    card.appendChild(dots);

    function goTo(index) {
      imageArray[current].style.opacity = '0';
      dots.querySelectorAll('span')[current].classList.remove('active');
      current = (index + imageArray.length) % imageArray.length;
      imageArray[current].style.opacity = '1';
      dots.querySelectorAll('span')[current].classList.add('active');
    }

    card.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isHorizontal = null;
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (window.innerWidth >= 990) return;

      const diffX = e.touches[0].clientX - touchStartX;
      const diffY = e.touches[0].clientY - touchStartY;

      // 方向がまだ未確定の場合に判定
      if (isHorizontal === null) {
        isHorizontal = Math.abs(diffX) > Math.abs(diffY);
      }

      // 横スワイプなら縦スクロールを止める
      if (isHorizontal) {
        e.preventDefault();
      }
    }, { passive: false }); // ← ここだけpassive: false

    card.addEventListener('touchend', function (e) {
      if (window.innerWidth >= 990) return;

      const diffX = e.changedTouches[0].clientX - touchStartX;

      if (isHorizontal && Math.abs(diffX) > 30) {
        // 横スワイプ → 画像切替
        if (diffX < 0) {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      }
      // タップ（横移動なし）→ 何もしない＝リンクがそのまま発火して遷移✅
    }, { passive: true });
  });
});
